var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((Array(_vm.noteMax)),function(elem,n){return _c('span',{key:n},[(_vm.getState(n) === -1)?_c('font-awesome-icon',{attrs:{"icon":"star"}}):(_vm.getState(n) === 0)?_c('font-awesome-icon',{attrs:{"icon":"star-half-alt"}}):_c('font-awesome-icon',{attrs:{"icon":['far', 'star']}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }